
// import { Feature } from "ol";
import { init_rentalResultsDisplay, rv_loc_search } from "../../rv_share_integration";
// import { display_potential_stays } from "../staySelectionScreen_scripts";
// import { add_rvShareMarkers, highlightRVshareMarker, unhighlightRVshareMarker } from "../tripPlanner_util/rvShare_map_utils";
// import { clearMapMarkers } from "../tripPlanner_util/tripPlanner_ol_map_util";
import { rvShare_click_log } from "../../log";
import { clearLayer } from "../../tripPlanner_new/map/helper_functions";
import { add_rvShareMarkers } from "../tripPlanner_util/rvShare_map_utils";

export function init_rvShare_listeners() {
    $(document).on("submit", "#searchRVrentals", function(event) {
        event.preventDefault();

        let s_date_str:string|undefined = $(this).find("#rvRental_sDate").val() as string;
        let e_date_str:string|undefined = $(this).find("#rvRental_eDate").val() as string;

        if (s_date_str != undefined && e_date_str != undefined) {
            try {
                let s_date:Date = new Date(s_date_str);
                let e_date:Date = new Date(e_date_str);

                if (s_date > e_date) {
                    $("#RVrentalsDisp").html("<h5>Please correct your dates</h5><br><h6>Pickup date is after dropoff date</h6>");
                    return;
                }
            } catch {
                //ignore
            };
        };


        let locStr:string = $(this).attr("loc");
        let loc:{latitude:number,longitude:number};
        if (locStr === undefined || locStr === null) return;
        try {
            loc = JSON.parse(locStr);
        } catch {
            return;
        };
        let page:number = parseInt($(this).attr("page"));
        if (Number.isNaN(page)) page = 1;

        let extraArgs:string = $(this).serialize();

        clearLayer(window.rvShareMarkerLayer);
        // clearMapMarkers(window.rvShareMarkerLayer);
        $("#RVrentalsDisp").html("");
        rv_loc_search(loc.latitude, loc.longitude, extraArgs, page).then(response => {
            init_rentalResultsDisplay(response.html, $("#RVrentalsDisp"))
            add_rvShareMarkers(response.data.data, window.rvShareMarkerLayer);
        }).catch(e => {
            console.error(e);
        });
    });

    // $(document).on("click", "#rvRentalPopup-close", function(){
    //     $("#rvRentalPopup").hide();
    // });

    // $(document).on("mouseover", "[rvRentalCard]", function() {
    //     let rvId:number;
    //     let rvId_str:string|undefined = $(this).attr("id");
    //     let rvMarkers:Feature[];
    //     if (rvId_str === undefined) return;
    //     rvId = parseInt(rvId_str);
    //     rvMarkers = window.rvShareMarkerLayer.getSource().getFeatures();
    //     for (let i:number = 0; i < rvMarkers.length; i++) {
    //         if (rvMarkers[i].getProperties()["id"] == rvId) {
    //             unhighlightRVshareMarker();
    //             highlightRVshareMarker(rvMarkers[i]);
    //         };
    //     };
    // });

    // $(document).on("mouseout", "[rvRentalCard]", unhighlightRVshareMarker);

    $(document).on("click", "[rentNowBtn]", function() {
        let card:JQuery<HTMLElement> = $(this).closest("[rvRentalCard]");
        let rvId:number = parseInt(card.attr("id"));
        let link:string = $(this).attr("href");
        rvShare_click_log(rvId, link);
    });
};